import React, {PropTypes, Component} from 'react';
import {FormattedMessage} from 'react-intl';
import moment from 'moment';
import _ from 'lodash';
import {serverDateFormat} from 'app/lib/format';
import Widget from '../../Widget';
import {colorsRGB} from 'app/globals';
import LineBarChart from 'app/lib/charts/LineBar';
import Preloader from 'routes/app/components/Preloader';
import './style.scss';

/*const chartData = {
 labels: ["January", "February", "March", "April", "May", "June", "July"],
 datasets: [
 {
 label: "My First dataset",
 type: "bar",
 fillColor: "rgba(220,220,220,0.2)",
 strokeColor: "rgba(220,220,220,1)",
 pointColor: "rgba(220,220,220,1)",
 pointStrokeColor: "#fff",
 pointHighlightFill: "#fff",
 pointHighlightStroke: "rgba(220,220,220,1)",
 data: [65, 59, 80, 81, 56, 55, 40]
 },
 {
 label: "My Second dataset",
 type: "line",
 fillColor: "rgba(151,187,205,0.2)",
 strokeColor: "rgba(151,187,205,1)",
 pointColor: "rgba(151,187,205,1)",
 pointStrokeColor: "#fff",
 pointHighlightFill: "#fff",
 pointHighlightStroke: "rgba(151,187,205,1)",
 data: [28, 48, 40, 19, 86, 27, 90]
 }
 ]
 };*/
const chartOptions = {
    showScale: true,
    scaleShowLabels: false,
    showTooltips: false,
    responsive: true,
    maintainAspectRatio: false
};

const rawDataToChartData = (raw) => {
    const data = {labels: [], datasets: []};

    if (_.isEmpty(raw)) {
        return data;
    }

    const dayStart = raw.startHour;
    const dayEnd = dayStart + raw.histCount.length;

    for (let i = dayStart; i < dayEnd; i++) {
        data.labels.push(i);
    }

    data.datasets.push({
        label: 'History count',
        type: 'bar',
        fillColor: 'rgba(220,220,220,0.2)',
        strokeColor: 'rgba(220,220,220,1)',
        pointColor: 'rgba(220,220,220,1)',
        pointStrokeColor: '#fff',
        pointHighlightFill: '#fff',
        pointHighlightStroke: 'rgba(220,220,220,1)',
        data: raw.histCount
    });

    data.datasets.push({
        label: 'Actual count',
        type: 'line',
        fillColor: 'transparent',
        strokeColor: `rgba(${colorsRGB.secondary.r},${colorsRGB.secondary.g},${colorsRGB.secondary.b},1)`,
        pointColor: 'transparent',
        pointStrokeColor: 'transparent',
        data: new Array(raw.histCount.length).fill(raw.actualCount)
    });

    return data;
};

class ActualTrucks extends Component {

    static propTypes = {
        rawData: PropTypes.object.isRequired,
        intl: PropTypes.object,
        fetch: PropTypes.func.isRequired,
        values: PropTypes.shape({
            dom: PropTypes.string
        })
    };
    
    componentWillMount() {
        this.fetchData();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.values.dom !== nextProps.values.dom) {
            this.fetchData(nextProps.values.dom);
        }
    }

    fetchData = (dom) => {
        dom = dom || this.props.values.dom;
        this.props.fetch({dom, date: moment().format(serverDateFormat)});
    };

    render() {
        const {rawData, intl:{formatMessage}} = this.props;

        return (
            <Widget
                    onRefresh={this.fetchData}
                    title={
                     <FormattedMessage id="dashboard.actualTrucks.title"
                      values={{day:formatMessage({id:'dayOfWeek.'+ (rawData.dayOfWeek || moment().isoWeekday()) })}} />}>

                {rawData.isLoading ?
                    <Preloader />
                    :
                    rawData.isError ?
                    <FormattedMessage id="dashboard.actualTrucks.fetchError" />
                    :
                    <div>
                        <LineBarChart data={rawDataToChartData(rawData)} options={chartOptions} height="250"/>
                        <p className="actual-trucks__on-terminal">
                            <FormattedMessage id="dashboard.actualTrucks.onTerminal" values={{count:''+(rawData.actualCount || 0)}}/>
                        </p>
                    </div>
                }
            </Widget>
        );
    }

}

export default ActualTrucks;